import { createAction } from "@reduxjs/toolkit";
import { BETRADAR_SETUP_FEATURE_KEY, HOF_SPORT_SORTING_FEATURE_KEY } from "./shared-sport-feature-keys.js";
const getBetRadarSportDataSuccess = createAction(
  `${BETRADAR_SETUP_FEATURE_KEY}/getBetRadarSportDataSuccess`
);
const getSportTopWinnersStart = createAction(`${HOF_SPORT_SORTING_FEATURE_KEY}/getSportTopWinnersStart`);
export {
  getBetRadarSportDataSuccess,
  getSportTopWinnersStart
};
